<template>
  <div class="module-container">
    <div class="container">
      <h2 class="module-title">四大生态：重塑商业逻辑</h2>
      <p class="module-subtitle">通过四个维度的深度协同，实现项目从发掘到交付的全生命周期闭环管理。</p>
      <div class="ecosystem-cards">
        <!-- 合伙人生态 -->
        <div class="ecosystem-card partner hover">
          <div class="card-header">
            <div class="card-icon">
              <img src="@/assets/img/home/FourEcosystems/icon_hhr.png">
            </div>
            <div class="card-title-group">
              <h3 class="card-title">合伙人生态</h3>
              <span class="card-tag partner-tag">商务层</span>
            </div>
          </div>
          <div class="card-content">
            <div class="content-left">
              <div class="sub-title partner-title">解决“项目从哪来”</div>
              <p class="card-description">通过纵横拉通的高中低层商务关系，实现信息共享与利益捆绑，让关系真正转化为生产力。你有的关系，我们帮你放大；你没有的关系，我们帮你连接。</p>
              <ul class="card-features">
                <li class="partner-feature">商务关系纵横拉通</li>
                <li class="partner-feature">利益分配透明机制</li>
              </ul>
            </div>
            <div class="content-right">
              <img src="@/assets/img/home/FourEcosystems/image_hhr.png">
            </div>
          </div>
        </div>
        <!-- 服务能力生态 -->
        <div class="ecosystem-card service">
          <div class="card-header">
            <div class="card-icon">
              <img src="@/assets/img/home/FourEcosystems/icon_fwnl.png">
            </div>
            <div class="card-title-group">
              <h3 class="card-title">服务能力生态</h3>
              <span class="card-tag service-tag">执行层</span>
            </div>
          </div>
          <div class="card-content">
            <div class="content-left">
              <div class="sub-title service-title">解决“谁去干、怎么干”</div>
              <p class="card-description">调度平台数千家异地服务单位，将您的成本中心转变为资本中心，实现全国范围高效交付。“你养人，别人买单；你接单，别人交付——这才是老板的杠杆。”</p>
              <ul class="card-features">
                <li class="service-feature">闲置产能弹性调度</li>
                <li class="service-feature">标准化工单管理系统</li>
              </ul>
            </div>
            <div class="content-right">
              <img src="@/assets/img/home/FourEcosystems/image_fwnl.png">
            </div>
          </div>
        </div>
        <!-- 供应链生态 -->
        <div class="ecosystem-card supply">
          <div class="card-header">
            <div class="card-icon">
              <img src="@/assets/img/home/FourEcosystems/icon_gyl.png">
            </div>
            <div class="card-title-group">
              <h3 class="card-title">供应链生态</h3>
              <span class="card-tag supply-tag">资源层</span>
            </div>
          </div>
          <div class="card-content">
            <div class="content-left">
              <div class="sub-title supply-title">解决“买什么、怎么便宜买”</div>
              <p class="card-description">依托海量集采优势大幅降低采购成本，并提供灵活的资金垫付，缓解项目周转压力。“别人买材料是成本，你买材料是利润——差的就是一个平台的量。”</p>
              <ul class="card-features">
                <li class="supply-feature">集采直通，成本直降 20%</li>
                <li class="supply-feature">金融利息自动化核算</li>
              </ul>
            </div>
            <div class="content-right">
              <img src="@/assets/img/home/FourEcosystems/image_gyl.png">
            </div>
          </div>
        </div>
        <!-- 解决方案生态 -->
        <div class="ecosystem-card solution">
          <div class="card-header">
            <div class="card-icon">
              <img src="@/assets/img/home/FourEcosystems/icon_jjfa.png">
            </div>
            <div class="card-title-group">
              <h3 class="card-title">解决方案生态</h3>
              <span class="card-tag solution-tag">赋能层</span>
            </div>
          </div>
          <div class="card-content">
            <div class="content-left">
              <div class="sub-title solution-title">解决“产品差异化”</div>
              <p class="card-description">整合全行业各应用场景的解决方案，比如智慧管廊、智慧电厂等解决方案，提升项目技术标竞争力与业务毛利率。“以前有单不敢接，因为没技术；现在技术找上门，只问你想不想接。”</p>
              <ul class="card-features">
                <li class="solution-feature">尖端技术方案快速导入</li>
                <li class="solution-feature">AI 赋能提升项目溢价</li>
              </ul>
            </div>
            <div class="content-right">
              <img src="@/assets/img/home/FourEcosystems/image_jjfa.png">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
};
</script>

<style lang="less" scoped>
.module-container {
  background-color: #f9f9f9;
  padding: 64px 0 80px;

  .container {
    max-width: @content-width;
    margin: 0 auto;
  }

  .module-title {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    text-align: center;
    margin-bottom: 16px;
    margin-top: 0;
  }

  .module-subtitle {
    font-size: 16px;
    color: #999;
    text-align: center;
    margin-bottom: 48px;
  }

  .ecosystem-cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;

    .ecosystem-card {
      background: linear-gradient(270deg, #FFFFFE 0%, #FFF7ED 100%);
      border: 1px solid #FFEAD3;
      border-radius: 12px;
      padding: 40px;
      position: relative;
      transition: all 0.3s ease;
      cursor: pointer;

      &.service {
        background: linear-gradient(270deg, #FEFFFF 0%, #EFF7FF 100%);
        border-color: #DBEAFE;
      }

      &.supply {
        background: linear-gradient(270deg, #F8FEFB 0%, #F0FDF4 100%);
        border-color: #DCFCE7;
      }

      &.solution {
        background: linear-gradient(270deg, #FEFBFF 0%, #FAF6FF 100%);
        border-color: #F3E8FF;
      }

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0px 4px 32px 0px rgba(0,0,0,0.1);
      }

      .card-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;

        .card-icon {
          width: 64px;
          height: 64px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          background-color: #fff;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

          img {
            width: 40px;
            height: 40px;
          }
        }

        .card-title-group {
          flex: 1;

          .card-title {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            margin: 0 0 8px 0;
          }

          .card-tag {
            display: inline-block;
            padding: 0 20px 0 30px;
            border-radius: 16px;
            line-height: 32px;
            font-size: 18px;
            font-weight: bold;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              left: 16px;
              top: 50%;
              transform: translateY(-50%);
              width: 6px;
              height: 6px;
              border-radius: 50%;
            }

            &.partner-tag {
              background-color: rgba(255, 130, 1, 0.1);
              color: #FF8201;

              &::before {
                background-color: #FF8201;
              }
            }

            &.service-tag {
              background-color: rgba(1, 111, 255, 0.1);
              color: #016FFF;

              &::before {
                background-color: #016FFF;
              }
            }

            &.supply-tag {
              background-color: rgba(35, 197, 94, 0.1);
              color: #23C55E;

              &::before {
                background-color: #23C55E;
              }
            }

            &.solution-tag {
              background-color: rgba(136, 99, 212, 0.1);
              color: #8863D4;

              &::before {
                background-color: #8863D4;
              }
            }
          }
        }
      }

      .card-content {
        display: flex;
        gap: 30px;
        align-items: flex-start;

        .content-left {
          flex: 1;

          .sub-title {
            font-size: 16px;
            font-weight: bold;
            margin-top: 12px;
            margin-bottom: 12px;
            padding-left: 8px;
            border-left: 3px solid;
            line-height: 18px;
            color: #333;

            &.partner-title {
              border-left-color: #FF8201;
            }

            &.service-title {
              border-left-color: #016FFF;
            }

            &.supply-title {
              border-left-color: #23C55E;
            }

            &.solution-title {
              border-left-color: #8863D4;
            }
          }

          .card-description {
            font-family: @font-medium;
            font-size: 16px;
            line-height: 1.6;
            color: #666;
            margin-bottom: 16px;
          }

          .card-features {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
              font-family: @font-medium;
              font-size: 14px;
              color: #666;
              padding-left: 24px;
              position: relative;
              + li {
                margin-top: 12px;
              }

              &::before {
                content: '✓';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 12px;
                height: 12px;
                border: 2px solid;
                border-radius: 50%;
                font-size: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              &.partner-feature::before {
                border-color: #FF8201;
                color: #FF8201;
              }

              &.service-feature::before {
                border-color: #016FFF;
                color: #016FFF;
              }

              &.supply-feature::before {
                border-color: #23C55E;
                color: #23C55E;
              }

              &.solution-feature::before {
                border-color: #8863D4;
                color: #8863D4;
              }

              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }

        .content-right {
          width: 180px;
          flex-shrink: 0;

          img {
            width: 180px;
            height: 180px;
            border-radius: 8px;
            object-fit: cover;
          }
        }
      }
    }
  }
}
</style>
